module.exports = __webpack_public_path__ + "assets/3CirclesIDetailed.3109cecd0d927230d229a9e5d195e5b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/3CirclesIDetailed.png
// module id = 445
// module chunks = 0